import { ResponsiveBar } from "@nivo/bar";
import React, {useContext} from "react";
import { BAR_CHART_DOT_COLORS } from "../../constants/Constants";
import "./ChartTooltip.css";
import CustomToolTipHost from "../../components/CustomToolTipHost/CustomToolTipHost";
import themeContext from "../../context/theme/ThemeContext";

const BarChartNivo = ({ data, keys, chartType, indexBy, yAxisText, totalCountForStudies }) => {
  const { getThemeColor,getAlterColor } = useContext(themeContext)
  const getFormattedLabelForEditedOrReturnedOrRaisedAlertChart = (label) => {
    let formattedLabel = label.split("-")[0];
    return formattedLabel;
  }

  const tooltipStyle = {
    root: {display:'flex',alignItems:'center' },
  };


  return (
    <ResponsiveBar
      data={data}
      keys={keys}
      indexBy={indexBy}
      margin={{ top: 50, right: 130, bottom: 50, left: 80 }}
      padding={0.3}
      groupMode={(chartType == "edit_reports_count" || chartType=="returned_studies_count" || chartType=="raised_alert_count") ? "stacked" : "grouped"}
      valueScale={{ type: "linear" }}
      indexScale={{ type: "band", round: true }}
      layout={(chartType == "edit_reports_count" || chartType=="returned_studies_count" || chartType=="raised_alert_count") ? "horizontal" : "vertical" }
      enableGridY = {(chartType == "edit_reports_count" || chartType=="returned_studies_count" || chartType=="raised_alert_count") ? false : true }
      enableGridX = {(chartType == "edit_reports_count" || chartType=="returned_studies_count" || chartType=="raised_alert_count") ? true : false }
      theme={{
        background: "none",
        axis: {
          fontSize: "14px",
          tickColor: getAlterColor("#ffffff","#000"),
          ticks: {
            line: {
              stroke: "#555555",
            },
            text: {
              fill: getAlterColor("#ffffff","#000"),
            },
          },
          legend: {
            text: {
              fill: getAlterColor("#ffffff","#000"),
            },
          },
        },
        grid: {
          line: {
            stroke: "#555555",
          },
        },
      }}
      colors={{ scheme: 'set2' }}
      // defs={[
      //   {
      //     id: "first",
      //     type: "patternDots",
      //     background: "inherit",
      //     color: BAR_CHART_DOT_COLORS[0],
      //     size: 4,
      //     padding: 1,
      //     stagger: true,
      //   },
      //   {
      //     id: "second",
      //     type: "patternLines",
      //     background: "inherit",
      //     color: BAR_CHART_DOT_COLORS[2],
      //     rotation: -45,
      //     lineWidth: 2,
      //     spacing: 10,
      //   },
      //   {
      //     id: "third",
      //     type: "patternLines",
      //     background: "inherit",
      //     color: BAR_CHART_DOT_COLORS[0],
      //     size: 2,
      //     padding: 1,
      //   },
      // ]}
      fill={[
        {
          match: {
            id: keys[0],
          },
          id: "first",
        },
        {
          match: {
            id: keys.length > 1 ? keys[1] : "",
          },
          id: "second",
        },
        {
          match: {
            id: keys.length > 2 ? keys[2] : "",
          },
          id: "third",
        },
      ]}
      borderColor={{
        from: "color",
        modifiers: [["darker", 1.6]],
      }}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: indexBy,
        // legend: indexBy,
        legendPosition: "middle",
        legendOffset: 40,
        format: e => ((chartType == "edit_reports_count" || chartType=="returned_studies_count" || chartType=="raised_alert_count") ? Number.isInteger(e) ? e : '' : null)
      }}
      maxValue={(chartType == "edit_reports_count" || chartType=="returned_studies_count" || chartType=="raised_alert_count") ? totalCountForStudies == 0 ? 1 : 'auto' : 'auto'}
      axisLeft={{
        tickSize: 5,
        tickPadding: (chartType == "edit_reports_count" || chartType=="returned_studies_count" || chartType=="raised_alert_count") ? 2 : 5,
        tickRotation: 0,
        legend: yAxisText,
        legendPosition: "middle",
        legendOffset: (chartType == "edit_reports_count" || chartType=="returned_studies_count" || chartType=="raised_alert_count") ? -75 : -50,
        itemOpacity: 1,
        format: (e) => (chartType == "edit_reports_count" || chartType=="returned_studies_count" || chartType=="raised_alert_count") ? 
                e.length > 10 ? e.substring(0, 10) + "..." : e
                : Number.isInteger(e) ? e : ''
      }}
      labelSkipWidth={12}
      labelSkipHeight={0}
      // labelTextColor={{
      //   from: "custom",
      //   modifiers: [["darker", 1.6]]
      // }}
      labelTextColor={getAlterColor("#ffffff","#000")}
      tooltip={(e) => {
        return (
          <div
            className="tooltip-container"
            style={{ transform: `translate(${e.absX},${e.absY})` }}
          >
            <div className="tooltip-container_in">
              <div className="tooltip-container_in__inside">
                <span
                  style={{
                    display: "block",
                    width: "12px",
                    height: "12px",
                    background: e.color,
                    marginRight: "7px",
                  }}
                ></span>
                <span style={{ color: "black" }}>
                {(chartType == "edit_reports_count" || chartType=="returned_studies_count" || chartType=="raised_alert_count") ? 
                  getFormattedLabelForEditedOrReturnedOrRaisedAlertChart(e.label) : e.label} <strong> {e.value}</strong>
                </span>
              </div>
            </div>
          </div>
        );
      }}
      legends={(chartType == "edit_reports_count" || chartType=="returned_studies_count" || chartType=="raised_alert_count") ? [] : [
        {
          dataFrom: "keys",
          anchor: "top-right",
          direction: "column",
          justify: false,
          translateX: 120,
          translateY: 0,
          itemsSpacing: 5,
          itemWidth: 100,
          itemHeight: 30,
          itemDirection: "left-to-right",
          itemTextColor: getAlterColor("rgb(255,255,255,0.8)","#000"),
          itemOpacity: 1,
          symbolSize: 30,
          effects: [
            {
              on: "hover",
              style: {
                itemOpacity: 10,
                itemTextColor:getAlterColor("#ffffff","#000"),
              },
            },
          ],
        },
      ]}
      role="application"
      barAriaLabel={(e) => e.id + ": " + e.formattedValue + e.indexValue}
    />
  );
};

export default BarChartNivo;
